import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getHomePlanStart,
  getHomePlanSuccess,
  getHomePlanFailure,
} from "../reducers/getHomePlanReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getHomePlan = createAsyncThunk(
  "getHomePlan",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getHomePlanStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Home/GetPlan?PRODUCT_ID=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getHomePlanSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getHomePlanFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
